export const internalInsightSample = {
  isInternalSample: true,
  state: "DRAFT",
  slug: "internal-template-sample",
  category: "Internal template test",
  title: "Internal article template sample. Not for publication.",
  standfirst: "This development-only page tests editorial hierarchy, responsive reading width and supported content components. It contains no public research or factual claims.",
  author: "Apping Technology",
  sections: [
    { id: "why-this-matters", title: "Why this matters" },
    { id: "main-analysis", title: "Main analysis" },
  ],
  question: "Can the article template present an answer-first structure clearly?",
  directAnswer: "Yes. This internal sample exists only to test the template. It is excluded from the production route system, sitemap, feed and Article structured data.",
  blocks: [
    { type: "heading", id: "why-this-matters", text: "Why this matters" },
    { type: "paragraph", parts: ["Editorial pages need clear hierarchy, readable line length and visible distinctions between analysis, evidence and limitations."] },
    { type: "callout", title: "Internal sample", text: "This is interface test content, not an Apping claim or a published insight." },
    { type: "heading", id: "main-analysis", text: "Main analysis" },
    { type: "paragraph", parts: ["The template supports semantic paragraphs, lists, tables, figures, callouts, citations and related resources without requiring every component in every article."] },
    { type: "bullets", items: ["Readable semantic content", "Responsive editorial layout", "Optional evidence components"] },
    { type: "table", caption: "Internal component coverage", headers: ["Component", "Purpose"], rows: [["Direct answer", "Early concise response"], ["Limitations", "Visible uncertainty"], ["References", "Claim-to-source traceability"]] },
  ],
  limitations: ["This sample evaluates presentation only.", "It is not evidence of a completed editorial article."],
  takeaways: ["Public routes require PUBLISHED status.", "Human approval remains mandatory."],
  sources: [],
  related: [{ label: "Return to Apping Insights", href: "/insights" }],
};
